/* Admin: read-only view of one partner's Hub clients (contacts, orders, refills, notes, follow-ups). */
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, getAuthHeader } from "@/App";
import { ClientList, FilterBar, applyFilter } from "@/portal/crm/ClientList";
import { ClientProfile } from "@/portal/crm/ClientProfile";
import { CrmKpis } from "@/portal/crm/PortalClients";

export const PartnerClientsTab = () => {
  const [partners, setPartners] = useState([]);
  const [pid, setPid] = useState("");
  const [d, setD] = useState(null);
  const [f, setF] = useState("all");
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);
  useEffect(() => { axios.get(`${API}/portal-admin/partners`, { headers: getAuthHeader() }).then((r) => setPartners(r.data)).catch(() => toast.error("Could not load partners")); }, []);
  useEffect(() => {
    if (!pid) return;
    setD(null); setSel(null);
    axios.get(`${API}/portal-admin/partners/${pid}/clients`, { headers: getAuthHeader() }).then((r) => setD(r.data))
      .catch((e) => toast.error(e?.response?.data?.detail || "Could not load clients"));
  }, [pid]);
  const today = d?.today || "";
  const rows = d ? applyFilter(d.clients, f, q, today) : [];
  const c = d?.clients.find((x) => x.key === sel);
  return (
    <div className="space-y-3" data-testid="pa-clients">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <select value={pid} onChange={(e) => setPid(e.target.value)} className="rounded border px-2 py-1.5" data-testid="pa-clients-partner">
          <option value="">Choose a partner…</option>
          {partners.map((p) => <option key={p.id} value={p.id}>{p.name} ({p.codes.join(", ")})</option>)}</select>
        <span className="rounded bg-slate-100 px-2 py-0.5 text-xs text-slate-600" data-testid="pa-clients-readonly">Read-only — partners manage their own clients in the Hub</span>
      </div>
      {pid && !d && <p className="text-sm text-slate-400">Loading…</p>}
      {d && <>
        <CrmKpis k={d.kpis} />
        <div className="grid gap-3 md:grid-cols-[300px_1fr]">
          <div className="space-y-2"><FilterBar f={f} setF={setF} q={q} setQ={setQ} /><ClientList rows={rows} sel={sel} onPick={setSel} /></div>
          {c ? <ClientProfile c={c} today={today} readOnly onBack={() => setSel(null)} /> : <p className="rounded-xl border border-dashed p-8 text-center text-sm text-slate-400">Pick a client to see the profile.</p>}
        </div>
      </>}
    </div>
  );
};
